import React, { useEffect, useState, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FaTrash } from "react-icons/fa";
import API from "../api";
import Layout from "../components/Layout";

const SupplierItems = () => {
    const { id } = useParams();

    const [data, setData] = useState([]);
    const [data3, setData3] = useState([]);
    const [data6, setData6] = useState([]);
    const [data12, setData12] = useState([]);

    // ================= TOTALS =================
    const [totals, setTotals] = useState({
        totalSubtotal: 0,
        totalPaid: 0,
        totalDue: 0
    });

    const [totals3, setTotals3] = useState({
        totalSubtotal: 0,
        totalPaid: 0,
        totalDue: 0
    });

    const [totals6, setTotals6] = useState({
        totalSubtotal: 0,
        totalPaid: 0,
        totalDue: 0
    });

    const [totals12, setTotals12] = useState({
        totalSubtotal: 0,
        totalPaid: 0,
        totalDue: 0
    });

    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [paidInput, setPaidInput] = useState(0);

    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);

    // MONTH FILTER
    const [filterMonth, setFilterMonth] = useState("all");

    const location = useLocation();
    const company = location.state?.company || "";

    // FETCH DATA
    const fetchAllData = useCallback(async () => {
        try {
            const [resAll, res3, res6, res12] = await Promise.all([
                API.get(`/suppliersorders/supplier/${id}`),
                API.get(`/suppliersorders/supplier/${id}?months=3`),
                API.get(`/suppliersorders/supplier/${id}?months=6`),
                API.get(`/suppliersorders/supplier/${id}?months=12`)
            ]);

            setData(Array.isArray(resAll.data?.data) ? resAll.data.data : []);
            setData3(Array.isArray(res3.data?.data) ? res3.data.data : []);
            setData6(Array.isArray(res6.data?.data) ? res6.data.data : []);
            setData12(Array.isArray(res12.data?.data) ? res12.data.data : []);

            setTotals(
                resAll.data?.totals || {
                    totalSubtotal: 0,
                    totalPaid: 0,
                    totalDue: 0,
                }
            );

            setTotals3(
                res3.data?.totals || {
                    totalSubtotal: 0,
                    totalPaid: 0,
                    totalDue: 0,
                }
            );

            setTotals6(
                res6.data?.totals || {
                    totalSubtotal: 0,
                    totalPaid: 0,
                    totalDue: 0,
                }
            );

            setTotals12(
                res12.data?.totals || {
                    totalSubtotal: 0,
                    totalPaid: 0,
                    totalDue: 0,
                }
            );

        } catch (err) {
            console.log(err);
        }
    }, [id]);


    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    useEffect(() => {
        setPage(1);
    }, [search, limit, filterMonth]);


    // ================= DELETE =================
    const handleDelete = async (orderId) => {

        if (!window.confirm("Delete item?")) return;

        try {

            await API.delete(`/suppliersorders/delete/${orderId}`);

            toast.success("Deleted");

            await fetchAllData();

        } catch {
            toast.error("Delete failed");
        }
    };

    // OPEN MODAL
    const openModal = (item) => {
        setSelectedItem(item);

        setPaidInput(item.paidAmount || 0);
        setShowModal(true);
    };

    // SAVE PAYMENT
    const handleModalSave = async () => {
        try {

            if (!selectedItem) {
                toast.error("Select item");
                return;
            }

            const paid = Number(paidInput) || 0;

            await API.put(
                `/suppliersorders/update/${selectedItem._id}`,
                {
                    paidAmount: paid
                }
            );

            toast.success("Payment Updated");

            setShowModal(false);
            setSelectedItem(null);

            await fetchAllData();

        } catch (err) {
            toast.error(
                err.response?.data?.message || "Update failed"
            );
        }
    };

    // ================= MONTH FILTER =================
    const getFilteredMonthData = () => {
        if (filterMonth === "3") return data3 || [];
        if (filterMonth === "6") return data6 || [];
        if (filterMonth === "12") return data12 || [];

        return data || [];
    };

    // ================= SEARCH FILTER =================
    const filteredMonthData = getFilteredMonthData() || [];

    const filteredData = filteredMonthData.filter((item) => {

        const companyName =
            (item.company || company || "")
                .toLowerCase();

        const productName =
            item.product?.name?.toLowerCase() || "";

        const categoryName =
            item.product?.category?.toLowerCase() || "";

        const searchText =
            search.toLowerCase();

        return (
            companyName.includes(searchText) ||
            productName.includes(searchText) ||
            categoryName.includes(searchText)
        );
    });

    // PAGINATION
    const perPage = Number(limit);

    const start = (page - 1) * perPage;

    const currentData =
        filteredData.slice(start, start + perPage);

    const totalPages =
        Math.ceil(filteredData.length / perPage);

    return (
        <Layout>
            <ToastContainer position="top-right" autoClose={2000} />

            {/* HEADER */}
            <div className="header-row">
                <h2>Supplier Items</h2>
            </div>

            {/* SUMMARY */}
            <div className="cards2">
                <div className="card2">
                    <h3>Last 3 Months</h3>
                    <p>Total Orders: {data3.length}</p>
                    <p>Total Subtotal: ₹{totals3.totalSubtotal}</p>
                    <p>Total Paid: ₹{totals3.totalPaid}</p>
                    <p>Total Due: ₹{totals3.totalDue}</p>
                </div>

                <div className="card2">
                    <h3>Last 6 Months</h3>
                    <p>Total Orders: {data6.length}</p>
                    <p>Total Subtotal: ₹{totals6.totalSubtotal}</p>
                    <p>Total Paid: ₹{totals6.totalPaid}</p>
                    <p>Total Due: ₹{totals6.totalDue}</p>
                </div>

                <div className="card2">
                    <h3>Last 1 Year</h3>
                    <p>Total Orders: {data12.length}</p>
                    <p>Total Subtotal: ₹{totals12.totalSubtotal}</p>
                    <p>Total Paid: ₹{totals12.totalPaid}</p>
                    <p>Total Due: ₹{totals12.totalDue}</p>
                </div>

                <div className="card2">
                    <h3>All Time</h3>
                    <p>Total Orders: {data.length}</p>
                    <p>Total Subtotal: ₹{totals.totalSubtotal}</p>
                    <p>Total Paid: ₹{totals.totalPaid}</p>
                    <p>Total Due: ₹{totals.totalDue}</p>
                </div>
            </div>


            {/* TABLE */}
            <div className="table-section">
                <div className="table-controls">

                    {/* LIMIT */}
                    <div>
                        Show

                        <select
                            value={limit}
                            onChange={(e) => setLimit(e.target.value)}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>

                        entries
                    </div>

                    {/* SEARCH + FILTER */}
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center"
                        }}
                    >

                        {/* SEARCH */}
                        <input
                            type="text"
                            placeholder="Search Company /Product / Category"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        {/* MONTH FILTER */}
                        <select
                            value={filterMonth}
                            onChange={(e) => {
                                setFilterMonth(e.target.value);
                                setPage(1);
                            }}
                        >
                            <option value="all">
                                All
                            </option>

                            <option value="3">
                                Last 3 Months
                            </option>

                            <option value="6">
                                Last 6 Months
                            </option>

                            <option value="12">
                                Last 1 Year
                            </option>

                        </select>

                    </div>
                </div>

                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Company Name</th>
                                <th>Product Name</th>
                                <th>Category</th>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Cost Price</th>
                                <th>Qty</th>
                                <th>Subtotal</th>
                                <th>Paid</th>
                                <th>Due</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item, i) => (
                                    <tr key={item._id}>
                                        <td>{i + 1}</td>
                                        <td>{item.company || company || "N/A"}</td>
                                        <td>{item.product?.name}</td>

                                        <td>
                                            {item.product?.category || "-"}
                                        </td>

                                        <td>
                                            {new Date(item.createdAt).toLocaleDateString()}
                                        </td>

                                        <td>
                                            {item.type}
                                        </td>
                                        {/* COST PRICE */}
                                        <td>
                                            ₹{item.costPrice}
                                        </td>

                                        {/* QTY */}
                                        <td>
                                            {
                                                item.type === "PCS"
                                                    ? `${item.qty} PCS`
                                                    : `${item.qty} KG`
                                            }
                                        </td>
                                        <td>₹{item.subtotal}</td>
                                        <td>₹{item.paidAmount}</td>
                                        <td>₹{item.dueAmount}</td>

                                        <td className="actions">

                                            {/* PAY BUTTON */}
                                            <button
                                                className="edit-btn"
                                                onClick={() => openModal(item)}
                                            >
                                                Pay
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="delete-btn"
                                                onClick={() => handleDelete(item._id)}
                                            >
                                                <FaTrash />
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: "center" }}>
                                        No Data Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="pagination">

                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {Array.from(
                        { length: totalPages },
                        (_, i) => (

                            <button
                                key={i}
                                className={
                                    page === i + 1
                                        ? "active"
                                        : ""
                                }
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </button>

                        )
                    )}

                    <button
                        disabled={
                            page === totalPages
                        }
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-box">

                        <h3>Update Payment</h3>

                        <p><b>Product:</b> {selectedItem?.product?.name}</p>
                        <p><b>Subtotal:</b> ₹{selectedItem?.subtotal}</p>

                        <input
                            type="number"
                            value={paidInput}
                            onChange={(e) => setPaidInput(e.target.value)}
                            placeholder="Enter paid amount"
                        />

                        {/* LIVE DUE */}
                        <p>
                            <b>Due:</b> ₹{(selectedItem?.subtotal || 0) - Number(paidInput || 0)}
                        </p>


                        <div className="modal-actions">
                            <button onClick={handleModalSave} className="save-btn">
                                Save
                            </button>

                            <button
                                onClick={() => setShowModal(false)}
                                className="cancel-btn"
                            >
                                Cancel
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </Layout>
    );
};

export default SupplierItems;


